import { createDomain } from 'effector';

export const rootDomain = createDomain('app');
rootDomain.sid = 'rootDomain';

window.effectorVars = {
  rootDomain
};
